import axios from 'axios';
import * as myConstClass from '../Config/config.js';
import { Encrypt } from '../Helpers/Common'; 
const END_POINT = myConstClass.BACKEND_ENDPOINT;
const AUTH_TOKEN = myConstClass.AUTH_TOKEN;

const headers = {
  "Access-Control-Allow-Origin": "*",
  'Access-Control-Allow-Credentials': true,
  'x-access-auth-token': '' + AUTH_TOKEN + '',
}

export async function applyCoupons(postdata) {
  console.log(postdata)
  return await Encrypt(postdata).then(res => {

    const postData = {
      "digest": res
    }

    return axios.post(END_POINT + '/subscription/applycoupon', postData, {
      headers: headers
    }).then(res => {
      const data = res;
      return data;
    });
  })
}